import {auth} from './middleware';
import EmptyParentComponent from './router_empty';
import WatchedRoutes from './router_watched';
import ImageAnalystRoutes from './router_image_analyst.js'

const AdminRoutes = [
{
	name: 'test',
	path: 'test',
	component: () => import('@/components/Reports/ReportWrapper.vue'),
	default: true,
	meta: { middleware: [ auth ] },
	
},
{
	name: 'query',
	path: 'query',
	component: () => import('@/components/query/Query.vue'),
	meta: { middleware: [ auth ] },
},
{
	name: 'watchedItems',
	path: 'watched',
	component: EmptyParentComponent,
	meta: { middleware: [ auth ] },
	children: WatchedRoutes
},
{
	name: 'ImageAnalyst',
	path: 'image-analyst',
	component: EmptyParentComponent,
	meta: { middleware: [ auth ] },
	children: ImageAnalystRoutes
},
{
	name: 'WatcherProcesses',
	path: 'process',
	component: EmptyParentComponent,
	meta: { middleware: [ auth ] },
	children: [
	{
		name: 'ManageProcesses',
		path: 'manage',
		component: () => import('@/components/watcher-processes/ManageProcesses.vue'),
		meta: { middleware: [ auth ] },
	}
	],
},
{
	name: 'reports',
	path: 'reports',
	component: EmptyParentComponent,
	children: [
	{
		name: 'generate',
		path: 'generate',
		component: () => import('@/components/Reports/ReportWrapper.vue'),
		meta: { middleware: [ auth ] },

	},
	],
},
{
	name: 'twitterSearch',
	path: 'twitter-query',
	component: () => import('@/components/query/Prefilters.vue'),
	meta: { middleware: [ auth ] },
	props: (route) => ({ 
		query: route.query.account,
		query: route.query.status,
		query: route.query.url,
		query: route.query.hashtag,
		filters: route.filters
	})
},
{
	name: 'twitterQueryBuilder',
	path: 'twitter-query/builder',
	component: () => import('@/components/query/Query.vue'),
	meta: { middleware: [ auth ] },
	props: (route) => ({ 
		query: route.query.account,
		query: route.query.status,
		query: route.query.url,
		query: route.query.hashtag,
		filters: route.filters
	})
},
{
	name: 'pages',
	path: 'pages',
	component: EmptyParentComponent,
	children: [
	{
		name: '404-pages',
		path: '404-pages',
		component: () => import('@/components/pages/404-pages/404PagesPage'),
		meta: { middleware: [ auth ] },

	},
	],
},
]

export default AdminRoutes;